/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { COMMERCIAL_WORKFLOW } from '../resources/endPoint';

export const getCommercialData = (token) => {
  return {
    url: COMMERCIAL_WORKFLOW,
    method: 'get',
    headers: { 'content-type': 'application/json', token: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editCommercialData = (newDetails) => {
  
  let url = `${COMMERCIAL_WORKFLOW}?id=${JSON.parse(newDetails.id)}`;

  return {
    url: url,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: newDetails,
  };
};

export const addCommercialData = (newDetails,token) => {
  return {
    url: COMMERCIAL_WORKFLOW,
    method: 'post',
    headers: { 'content-type': 'application/json', token: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: newDetails,
  };
};

export const deleteCommercialData = (newDetails) => {
  let url = `${COMMERCIAL_WORKFLOW}?id=${JSON.parse(newDetails.id)}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: newDetails,
  };
};
